module.exports = __webpack_public_path__ + "assets/img/bg-terminal.ecd49640.png";